import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Transparencia() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={8}>
              <div className="about-hero-copy">
                <span className="about-kicker">Transparência</span>
                <h1>Transparência</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-content-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={8}>
              <div className="about-text-panel">
                <p>Em atendimento ao disposto na Lei Complementar n. 210/2024, na decisão do STF de 02/12/2024 e no Parecer de Força Executória n. 00446/2024/SGCT/AGU, declaramos que esta Organização da Sociedade Civil não recebeu Emendas Parlamentares Federais entre 2020 e 2024.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Transparencia;